import { getSetting, setSetting, settingKeys } from './settings';

// Dark mode is a preference like any other, so it lives in the settings blob rather than in a key
// of its own. Existing users are moved across by the legacy migration in storage.js.
export const isDarkTheme = () => getSetting(settingKeys.darkTheme) === true;

export const applyTheme = () => {
  if (isDarkTheme()) {
    document.body.classList.replace('light', 'dark');
  }
};

export const setDarkTheme = () => {
  setSetting(settingKeys.darkTheme, true);
  document.body.classList.replace('light', 'dark');
};

export const removeDarkTheme = () => {
  setSetting(settingKeys.darkTheme, false);
  document.body.classList.replace('dark', 'light');
};

export const renderPartColor = (partName, baseClasses) => {
  let classes = baseClasses;

  if (partName === 'Intro') classes += ' intro';
  if (partName === 'Verse') classes += ' verse';
  if (partName === 'Pre-chorus') classes += ' pre-chorus';
  if (partName === 'Chorus') classes += ' chorus';
  if (partName === 'Bridge') classes += ' bridge';
  if (partName === 'Music') classes += ' music';
  if (partName === 'Instrumental') classes += ' instrumental';
  if (partName === 'Outro') classes += ' outro';
  if (partName === 'Refrain') classes += ' refrain';
  if (partName === 'Tag') classes += ' tag';
  if (partName === 'Section') classes += ' section';
  if (partName === 'Note') classes += ' note';
  if (partName === 'Hidden') classes += ' hidden-note';

  return classes;
};

const theme = {
  applyTheme,
  isDarkTheme,
  setDarkTheme,
  removeDarkTheme,
  renderPartColor,
};

export default theme;
